export const getCompressedBackgroundImage = ({$img, path, modifiers = {format: 'webp', quality: 100}}) => {
    try {
        const imageUrl = $img(
            path,
            modifiers,
        );

        return {
            backgroundImage: `url(${imageUrl})`,
        };
    } catch (error) {
        console.error(error);
    }
};
